import Smartphones from 'Messages/views/ConversationsView/containers/Smartphones'
import Tablets from 'Messages/views/ConversationsView/containers/Tablets'

import {getCurrentDeviceView} from 'shared/helpers/utils'

const MessagesView = getCurrentDeviceView(Smartphones, Tablets)

export default MessagesView
